/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Support_TextInputs */

const en_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If this issue persists, please contact our support team:`)
};

const fr_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si ce problème persiste, veuillez contacter notre équipe de support :`)
};

const de_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollte dieses Problem weiterhin bestehen, kontaktieren Sie bitte unser Support-Team:`)
};

const it_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se il problema persiste, contatta il nostro team di supporto:`)
};

const ru_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если проблема не исчезнет, пожалуйста, свяжитесь с нашей службой поддержки:`)
};

const es_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si el problema persiste, comuníquese con nuestro equipo de soporte:`)
};

const zh_cn2_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果问题仍然存在，请联系我们的支持团队：`)
};

const ja_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この問題が解決しない場合は、サポート チームにお問い合わせください。`)
};

const hi_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि यह समस्या बनी रहती है, तो कृपया हमारी सहायता टीम से संपर्क करें:`)
};

const pt_pt2_offline_support_text = /** @type {(inputs: Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se o problema persistir, entre em contato com nossa equipe de suporte:`)
};

/**
* | output |
* | --- |
* | "If this issue persists, please contact our support team:" |
*
* @param {Offline_Support_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_support_text = /** @type {((inputs?: Offline_Support_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Support_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_support_text(inputs)
	if (locale === "de") return de_offline_support_text(inputs)
	if (locale === "it") return it_offline_support_text(inputs)
	if (locale === "ru") return ru_offline_support_text(inputs)
	if (locale === "es") return es_offline_support_text(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_support_text(inputs)
	if (locale === "ja") return ja_offline_support_text(inputs)
	if (locale === "hi") return hi_offline_support_text(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_support_text(inputs)
	return en_offline_support_text(inputs)
});